import { OSHighwayInfo } from "../../../../types/OSHighwayFileSummary/OSHighwayInfo";
import { useContext, useEffect, useState } from "react";
import { Table } from "react-bootstrap";
import { TableContainer } from "../../../../@ui/TableContainer";
import { LayerContext } from "../LayerContext";

const OSHighwaysFileSummary = () => {

  const value = useContext(LayerContext);
  const { layerInfo} = value!;
  const osHighwayInfo = layerInfo as OSHighwayInfo;

  return (<>
  <TableContainer>
      <Table striped bordered hover>
        <thead>
          <tr>
            <th className="p-2 text-white bg-primary">Sr.No.</th>
            <th className="p-2 text-white bg-primary">File Type</th>
            <th className="p-2 text-white bg-primary">Files Received Last Import</th>
            <th className="p-2 text-white bg-primary">Total Records Last Import</th>
            <th className="p-2 text-white bg-primary">Files Received Current Import</th>
            <th className="p-2 text-white bg-primary">Total Records Currrent Import</th>
          </tr>
        </thead> 
        <tbody>
            {osHighwayInfo?.osHighwaysFileSummary?.map((fileSummary) => (
                <tr key={fileSummary.srNo}>
                  <td>{fileSummary.srNo}</td>
                  <td>{fileSummary.fileType}</td>
                  <td>{fileSummary.filesReceivedInLastImport}</td>
                  <td>{fileSummary.totalRecordsLastImport}</td>
                  <td>{fileSummary.filesReceivedInCurrentImport}</td>
                  <td>{fileSummary.totalRecordsCurrentImport}</td>
                </tr>
              ))}
            {osHighwayInfo?.osHighwaysFileSummary &&
              osHighwayInfo.osHighwaysFileSummary.length === 0 && (
                <tr>
                  <td colSpan={6} className="text-center">
                    No records found.
                  </td>
                </tr>
              )}
          </tbody>
        </Table>
        </TableContainer>
    </>
  );
};

export default OSHighwaysFileSummary;
